import { Box, Skeleton } from "@mui/material";
import { useSelector } from "react-redux";
import { selectTeam } from "./TeamSlice";

export default function TeamItem(props) {
    const teams = useSelector(selectTeam);
    const { code } = { ...props };
    const team = teams[code];
    if (!team) {
        return teams.loading ? <Skeleton animation={false} /> : null;
    }
    const imgSrc = "https://api.fifa.com/api/v3/picture/flags-sq-1/" + code;
    return (<Box>
        <img src={imgSrc} alt={code} height="14" style={{ verticalAlign: "middle", marginLeft: "4px", marginRight: "4px" }} />
        {team.name}
    </Box>);
}